import Icon from '@mdi/react';
import { mdiLogout } from '@mdi/js';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import { useEffect, useState } from 'react';
import { postApiV2MemberKillSession } from '@shared/integrations/taf-api/v2/features/member/member.ts';
import { postUmbracoApiUserSignOut } from '@shared/integrations/umbraco-taf-api/features/v1/v1.ts';
import { useQueryClient } from '@tanstack/react-query';
import { Link, useRouter } from '@tanstack/react-router';
import useGetGlobalSiteSettings from '@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings.ts';
const Logout = () => {
    const [loading, setIsLoading] = useState(false);
    const { loginUrl } = useGetGlobalSiteSettings();

    const cleanUp = () => {
        setIsLoading(true);
        useApplicationStore.getState().cleanUp();
    };
    const queryClient = useQueryClient();
    const router = useRouter();
    useEffect(() => {
        postApiV2MemberKillSession();
        postUmbracoApiUserSignOut();
        queryClient.removeQueries();
        router.clearCache();
    }, []);

    return (
        <div
            className='modal modal-system-message'
            id='modal-session-timeout'
            tabIndex={-1}
            role='dialog'
            aria-labelledby='sessionTimeout'
            aria-hidden='true'
            data-focus='false'
            style={{ display: 'block' }}
        >
            <div className='content'>
                {loading ? (
                    <div className={'spinner spinner-linear spinner-xl  mx-auto fade-in-medium'}></div>
                ) : (
                    <div
                        className='alert alert-info m-3 py-5 px-4 px-sm-5 d-flex flex-wrap'
                        style={{ maxWidth: '25rem' }}
                        role='alert'
                    >
                        <Icon
                            path={mdiLogout}
                            className='mdi mr-1'
                        />
                        <div>
                            <h5 className='alert-heading mb-4'>Du har blivit utloggad</h5>
                            <Link
                                onClick={() => cleanUp()}
                                to={'/$'}
                                params={{ _splat: loginUrl ?? '/' }}
                                className='btn btn-primary'
                            >
                                Till startsidan
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Logout;
